var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solid/credit-card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.80002 4.7998C3.47454 4.7998 2.40002 5.87432 2.40002 7.19981V8.3998H21.6V7.1998C21.6 5.87432 20.5255 4.7998 19.2 4.7998H4.80002Z",
    fill: "#4FC0CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6 10.7998H2.40002V16.7998C2.40002 18.1253 3.47454 19.1998 4.80002 19.1998H19.2C20.5255 19.1998 21.6 18.1253 21.6 16.7998V10.7998ZM4.80002 15.5998C4.80002 14.9371 5.33728 14.3998 6.00002 14.3998H7.20002C7.86277 14.3998 8.40002 14.9371 8.40002 15.5998C8.40002 16.2625 7.86277 16.7998 7.20002 16.7998H6.00002C5.33728 16.7998 4.80002 16.2625 4.80002 15.5998ZM10.8 14.3998C10.1373 14.3998 9.60002 14.9371 9.60002 15.5998C9.60002 16.2625 10.1373 16.7998 10.8 16.7998H12C12.6628 16.7998 13.2 16.2625 13.2 15.5998C13.2 14.9371 12.6628 14.3998 12 14.3998H10.8Z",
    fill: "#4FC0CF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.4c3063749bdaa12e990f44219178e23c.svg";
export { ForwardRef as ReactComponent };